<template>

    <div class="content-load">

        <Top v-show="!isMobile || modo != 'conversa'"></Top>

        <header id="header-container2" class="fullwidth header-chat hidden-lg hidden-xl hidden-md hidden-sm" v-if="isMobile && modo == 'conversa'">

            <div id="header">
                <div class="container" style="width: 100%;">
                    <div class="left-side">
                        
                        
                        <div class="left-button hidden-lg hidden-xl">
                            
                            <a v-on:click="voltar()">
                                <i class="material-icons">arrow_back</i>
                            </a>
                            
                        </div>

                        <div id="logo">
                            <a>{{conversa.usuario.nome}}</a>
                            
                        </div>

                        <div class="clearfix"></div>
                        
                    </div>
                    <div class="right-side">
                        <div class="header-widget">

                            <a class="account-header">
                                <div class="uploadButton">
                                    <input class="uploadButton-input" type="file" name="upload-chat" @change="getBase64" accept="image/*" id="upload-chat" />
                                    <label class="uploadButton-button" for="upload-chat">
                                        <i class="material-icons">attach_file</i>
                                    </label>
                                </div>
                            </a>
                            
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div style="margin-top: -60px" v-if="isMobile && modo == 'conversa'" class="hidden-xs hidden-lg hidden-xl"></div>
            <div class="dashboard-content-container" data-simplebar>

                <div class="dashboard-content-inner" >
                    <div class="row">
                        <div class="col-lg-12">
    
                            <div class="messages-container margin-top-0">

                                <div class="messages-container-inner">

                                    <div class="messages-inbox" v-show="isMobile ? (modo == 'inbox') : true">
                                        <ul>

                                            <li v-show="chat.itens.length > 0" class="title">
                                                <h4>Conversas</h4>
                                            </li>

<!-- 
                                            <li v-show="chat.loaded && chat.itens.length == 0" style="border: none;">
                                                <div class="job-overview cart-empty" style="margin-top: 32vh;">

                                                    <div class="job-overview-inner">
                                                        <center>
                                                            <i class="material-icons big">mood_bad</i>
                                                            <p>Nenhum resultado encontrado.</p>

                                                        </center>
                                                    </div>      
                                                </div>                                                  
                                            </li>   -->   
                                            <li v-for="(item, index) in chat.itens" v-bind:class="{'active-message': item.usuarioCod == conversa.usuarioCod}">
                                                <a v-on:click="open(item.usuarioCod, item.cod)">
                                                    <div class="message-avatar"><div class="img" v-bind:style="{ 'background-image': 'url(' + item.usuario.imagem + ')' }"></div></div>

                                                    <div class="message-by">
                                                        <div class="message-by-headline">
                                                            <h5>{{item.usuario.nome}}</h5>
                                                            <span class="datetime-xs">{{item.atualizacaoFormatado}}</span>
                                                        </div>
                                                        <p v-bind:class="{'bold': item.pendente}">
                                                            <span class="dashboard-status-button gray" v-show="item.quantidade">{{item.quantidade}}</span>
                                                            <span v-show="item.mensagem != '**[ARQUIVO]**'" v-html="item.mensagem"></span>
                                                            <span v-show="item.mensagem == '**[ARQUIVO]**'">
                                                                <i class="material-icons">photo</i> Imagem
                                                            </span>
                                                        </p>
                                                    </div>
                                                </a>
                                            </li>

                                            <li v-show="usuarios.itens.length > 0" class="title">
                                                <h4>Usuários disponíveis</h4>
                                            </li>

                                            <li v-for="(item, index) in usuarios.itens">
                                                <a v-on:click="open(item.cod)">
                                                    <div class="message-avatar"><div class="img" v-bind:style="{ 'background-image': 'url(' + item.imagem + ')' }"></div></div>

                                                    <div class="message-by">
                                                        <div class="message-by-headline">
                                                            <h5 style="max-width: 100%;">{{item.nome}}</h5>
                                                        </div>
                                                        <p style="opacity: 0.7;">Toque para falar com o usuário</p>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="message-content empty hidden-xs hidden-md" v-show="modo == 'inbox'">

                                        <div class="message-content-inner">
                                            <center>
                                                <i class="material-icons">message</i>
                                                <h2>Toque em uma conversa para iniciar</h2>
                                            </center>
                                        </div>

                                    </div>

                                    <div class="message-content" v-show="modo == 'conversa'">

                                        <div class="messages-headline hidden-xs">
                                            <h4>
                                                <a class="hidden-xs" v-on:click="voltar()" style="font-weight: 100; margin-right: 10px;">
                                                    <i class="material-icons">arrow_back</i>
                                                </a>
                                                {{conversa.usuario.nome}}
                                            </h4>
                                            <div class="uploadButton float-right">
                                                <input class="uploadButton-input" type="file" name="upload-chat" @change="getBase64" accept="image/*" id="upload-chat" />
                                                <label class="uploadButton-button" for="upload-chat">
                                                    <i class="material-icons">attach_file</i>
                                                </label>
                                            </div>

                                        </div>
                                        
                                        
                                        <div class="message-content-inner">

                                            <div v-for="item2 in conversa.mensagens">
<!--                                                <div class="message-time-sign">
                                                    <span>28 June, 2019</span>
                                                </div> -->

                                                <div class="message-bubble " v-bind:class="{'me': item2.de == form._cod}">
                                                    <div class="message-bubble-inner">
                                                        <div class="message-avatar"><div class="img" v-bind:style="{ 'background-image': 'url(' + (item2.de == form._cod ? $root.user.imagem : conversa.usuario.imagem) + ')' }"></div></div>
                                                        <div class="message-text">
                                                            <p v-show="item2.texto" v-html="item2.texto"></p>
                                                            <img v-if="item2.arquivo" v-on:click="openImagem(item2.arquivo)" v-on:load="toBottom('teste')" :src="item2.arquivo" width="100%" />
                                                            <small>{{item2.datahora | formatDate}}</small>
                                                        </div>
                                                    </div>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="message-reply hidden-xs">
                                            <textarea cols="1" rows="1" v-model="conversa.texto" placeholder="Escreva sua mensagem aqui.." data-autoresize></textarea>
                                            <button class="button ripple-effect" v-on:click="submitMensagem()">
                                                <i class="material-icons">
                                                    send
                                                </i>
                                            </button>
                                        </div>

                                    </div>
                                    
                                    <div class="message-reply hidden-lg hidden-md hidden-xl hidden-sm" v-show="modo == 'conversa'">
                                        <textarea cols="1" rows="1" v-model="conversa.texto" placeholder="Escreva sua mensagem aqui.." data-autoresize></textarea>
                                        <button class="button ripple-effect" v-on:click="submitMensagem()" v-bind:class="{'disabled': loading.submitMensagem}">
                                            <i class="material-icons">
                                                send
                                            </i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                        
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import { isMobile } from 'mobile-device-detect';

export default {
    name: 'Chat',
    components: {
        'Top': Top,
        'Sidebar': Sidebar,
        'Toolbar': Toolbar
    },       
    data () {
        var self = this;
        return {
            isMobile:               isMobile,
            form: {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
            },
            modo:                   "inbox",
            realtime:               {},
            chat:                   {
                "loaded":           false,
                "itens":            []
            },
            usuarios:               {
                "itens":            []
            },
            conversa:               {
                "index":            -1,
                "texto":            "",
                "arquivo":          "",
                "chatCod":          "",
                "usuarioCod":       "",
                "chat":             null,
                "mensagens":        [],
                "usuario":          {
                }
            },
            loading: {
                "delItem":          false,
            }
        }
    },
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },       
    methods: {
        setModo(modo) {
            var self            = this;
            self.modo           = modo;
            self.$forceUpdate();
        },
        voltar() {
            var self            = this;
            self.conversa       = {
                "index":            -1,
                "texto":            "",
                "arquivo":          "",
                "chatCod":          "",
                "usuarioCod":       "",
                "chat":             null,
                "mensagens":        [],
                "usuario":          {
                }
            };
            self.setModo("inbox");
        },
        getBase64: function(event) {

            var self            = this;
            
            if (event.target.files[0]) {
                loading.show();
                getDataUrl(event.target.files[0], function(result) {
                // reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.1, blob => {
                    // blobToBase64(blob, function(result) {
                        self.conversa.arquivo   = result;
                        self.submitMensagem();
                    // });
                });
            }   

        },
        submitMensagem() {
            var self                    = this;
            return new Promise(function(resolve, reject) {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.usuarioCod         = self.conversa.usuarioCod;
                form.texto              = self.conversa.texto;
                form.arquivo            = self.conversa.arquivo;
                if (!form.arquivo && !form.texto.trim()) return false;
                self.loading.submitMensagem = true;
                self.conversa.texto     = "";
                self.conversa.arquivo   = "";

                var refreshUsuarios     = false;
                if (self.conversa.mensagens.length == 0) {
                    refreshUsuarios     = true;
                }

                axios.post("api/chat.php", form)
                .then(response => {
                    
                    self.loading.submitMensagem = false;
                    resolve(response.data.result);
                    if (refreshUsuarios) {
                        self.getUsuarios();
                    }
                    loading.hide();

                })
                .catch(error => {
                    
                    self.loading.submitMensagem = false;
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    
                });             
            });             
        },
        getChat() {
            var self                    = this;
            return new Promise(function(resolve, reject) {
                var form        = JSON.parse(JSON.stringify(self.form));

                axios.get("api/chat.php", {params: form, db: "chat"})
                .then(response => {
                    
                    self.chat.itens     = response.data.result;
                    self.chat.loaded    = true;
                    self.$forceUpdate();
                    resolve(response.data.result);

                })
                .catch(error => {
                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    
                });
            });
        },
        getUsuarios() {
            var self                    = this;
            return new Promise(function(resolve, reject) {
                var form        = JSON.parse(JSON.stringify(self.form));
                form.tipo       = "usuarios";
                axios.get("api/chat.php", {params: form, db: "chatUsuarios"})
                .then(response => {
                        
                    console.log("usuarios", response)
                    self.usuarios.itens = response.data.result;
                    self.$forceUpdate();                    
                    resolve(response.data.result);

                })
                .catch(error => {
                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    
                });
            });
        },
        getMensagens() {
            var self                    = this;
            return new Promise(function(resolve, reject) {
                var form        = JSON.parse(JSON.stringify(self.form));
                form.usuarioCod = self.conversa.usuarioCod;

                axios.get("api/chat.php", {params: form, db: "chatMensagens"})
                .then(response => {
                    
                    var itens               = response.data.mensagens.sort(dynamicSortMultiple("datahora"));
                    self.conversa.usuario   = response.data.usuario;
                    self.conversa.mensagens = itens;
                    resolve(response.data.result);
                    self.$forceUpdate();

                })
                .catch(error => {
                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    
                });
            });
        },
        toBottom(t) {
            console.log("toBottom", t)
            setTimeout(function() {
                jQuery(".message-content:not(.empty) .message-content-inner")[0].scrollTo({
                    top: jQuery(".message-content:not(.empty) .message-content-inner")[0].scrollHeight
                });
                setTimeout(function() {
                    jQuery(".message-content:not(.empty) .message-content-inner")[0].scrollTo({
                        top: jQuery(".message-content:not(.empty) .message-content-inner")[0].scrollHeight
                    });
                }, 100);                    
            }, 0);
        },
        addMensagem(obj) {
            var self                = this;
            if (self.conversa.usuarioCod) {
                var exists  = false;
                self.conversa.mensagens.forEach(function(item) {
                    if (item.cod == obj.cod) exists = true;
                });
                if (!exists) {
                    self.conversa.mensagens.push(obj);
                    self.conversa.mensagens     = self.conversa.mensagens.sort(dynamicSortMultiple("datahora"));
                    self.$forceUpdate();
                }
                self.toBottom();
            }

            var index = -1;
            self.chat.itens.forEach(function(item, i) {
                if (item.cod == obj.chatCod) index = i;
            });

            if (self.chat.itens[index]) {
                self.chat.itens[index].atualizacao  = obj.datahora;
                self.chat.itens[index].mensagem     = obj.texto;

                if (self.conversa.usuarioCod != obj.de && self.conversa.usuarioCod != obj.para) {
                    self.chat.itens[index].pendente     = true;
                    if (!self.chat.itens[index].quantidade) {
                        self.chat.itens[index].quantidade   = 1;
                    } else {
                        self.chat.itens[index].quantidade   ++;
                    }
                }
            }
            self.$forceUpdate();

        },
        initRealTime() {
            var self                = this;
            Pusher.logToConsole     = true;
            self.realtime.client    = new Pusher(self.$root.config.pusher.key, {
                cluster: 'us2'
            });
            self.realtime.channelUsuario    = self.realtime.client.subscribe("chat-usuario-" + self.form._cod);
            self.realtime.channelUsuario.bind("update", function(data) {
                // console.log("message", data);
                if (data.mensagem) {
                    self.addMensagem(data.mensagem);
                    self.getChat();
                }
            });
        },          
        open(usuarioCod, cod) {
            var self                    = this;
            return new Promise(function(resolve, reject) {
                self.conversa.usuarioCod    = usuarioCod;
                self.setModo("conversa");
                loading.show();

                if (typeof cod != "undefined") {
                    var index = -1;
                    self.chat.itens.forEach(function(item, i) {
                        if (item.cod == cod) index = i;
                    });
                    self.conversa.index                 = index;
                    self.chat.itens[index].pendente     = false;
                    self.chat.itens[index].quantidade   = 0;
                    self.$forceUpdate();
                }

                self.getMensagens().then(function() {
                    loading.hide();
                    self.toBottom();                        
                }).catch(function(error) {
                    loading.hide();
                });
            });
        },
        openImagem: function(img) {
            var self                = this;
            self.modalImagem.setContent('<a href="' + img + '" target="_blank"><img src="' + img + '" width="width: 100%;" /></a>');
            self.modalImagem.open();
            setTimeout(function() {
                $(".modal-image-preview .tingle-btn a").off("click");
                $(".modal-image-preview .tingle-btn a").on("click", function() {
                    img             = "http://" + window.location.host + "/" + img;
                    var link        = document.createElement('a');
                    link.target     = "_blank";
                    link.href       = img;
                    document.body.appendChild(link);
                    link.click();                       
                });
            }, 500);                
        },
        init: function() {
            console.log("init()");
            var self = this;
            self.initRealTime();
            Promise.all([self.getUsuarios(), self.getChat()]).then(function() {
                loading.hide();
            }).catch(function(error) {
                loading.hide();
            }); 
        }
    },
    beforeMount: function(e){
        var self            = this;
        loading.show();
        self.modalImagem    = new tingle.modal({
            footer:         false,
            stickyFooter:   false,
            closeMethods:   ['overlay', 'button', 'escape'],
            closeLabel:     "Fechar",
            cssClass:       ["modal-image-preview"],
            onOpen: function() {
            },
            onClose: function() {
            },
            beforeClose: function() {
                return true; 
                return false;
            }
        });   
    },      
    // mounted: function() {
    created: function() {
        var self = this;
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }                 
        // setTimeout(function() {
            // self.open("<?php echo addslashes($mysqli->real_escape_string(strip_tags(@$_GET["c"]))) ?>");
        // }, 0);
    },
    beforeDestroy: function() {
        var self = this;
        self.realtime.client.disconnect();

    }      
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*chat*/

    .page-chat .dashboard-content-inner {
        padding: 20px;
    }

    .messages-container {
        border: 2px solid #ddd;
    } 

    .messages-inbox {
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
        border-right: 1px solid #ddd;
    }

    .messages-headline {
        border-color: #ddd;
        background: #efefef;
    }

    .messages-headline h4 {
        font-size: 20px;
    }

    .messages-inbox ul li {
        border-bottom: 1px solid #ddd;
    }

     .messages-inbox ul {
        overflow-y: scroll;
        height: 100%;
        width: 100%;
        /*width: calc(100% + 18px);*/
    }

    .message-content-inner,
    .messages-container-inner {
        overflow-y: scroll;
        height: 95vh;
        width: 100%;
        /*width: calc(100% + 18px); */
    }

    .message-reply {
        padding: 10px;
        padding-left: 20px;
    }

    .page-chat .datetime-xs {
        /*display: none;*/
    }
    .page-chat .messages-container-inner .message-by-headline h5 {
        font-weight: bold;
        font-size: 16px;
        margin-top: 3px;
    }
    .page-chat .messages-container-inner .messages-inbox ul li a {
        padding: 20px;
        padding-left: 20px;
    }
    .page-chat .messages-container-inner .messages-inbox .message-avatar {
        left: 12px;
    }

    .page-chat .messages-container-inner .message-by-headline span {
        float: right;
        font-size: 11px;
        
        top: 22px;
        right: 11px;    
    }
    .page-chat .message-bubble .message-text p {
        margin-bottom: 0px;
        word-break: break-all;
    }
    .page-chat .message-bubble:not(.me) .message-text small {
        font-size: 8px;
        /*position: absolute;*/
        color: #666;
        width: 100%;
        display: block;
        margin-left: -10px;
    }
    .page-chat .message-bubble.me .message-text small {
        font-size: 8px;
        color: #fff;
        text-align: right;
        width: 100%;
        display: block;
        float: right;
        margin-right: -10px;
    }   
    .page-chat .message-bubble .message-text {
        padding-bottom: 0px;
        min-width: 105px;
    }
    .page-chat .bold {
        color: #000;
        font-weight: bold !important;
    }
    .page-chat p.bold {
        color: #000 !important;
    }
    .page-chat .messages-inbox .dashboard-status-button  {
        margin-bottom: 0px;
        top: 1px;
    }
    .page-chat .message-by-headline h5 {
        height: 23px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;        
    }
    .page-chat .message-by-headline {
        height: 26px;
    }
    .page-chat .messages-container-inner .message-avatar .img {
        height: 60px;
        width: 60px;
        border-radius: 5px;
        border: 2px solid #ddd;
        background-size: 100% auto;
        background-position: center;
        background-repeat: no-repeat;
    }
    .page-chat .message-bubble .message-text p a {
        color: #fff;
        text-decoration: underline;
    }

    .hidden-render {
        display: none !important;
    }

    .page-chat li.title {
        pointer-events: none !important;
        background: #efefef;
    }
    .page-chat li.title h4 {
        padding-left: 10px;
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
    }

    .page-chat .header-chat .right-side .header-widget {
        padding-right: 0px;
    }

    .page-chat .messages-container-inner .messages-inbox .message-by p i {
        font-size: 16px;
        position: relative;
        top: 3px;
    }

    .page-chat .modal-image-preview .tingle-modal-box__footer {
        display: block;
        width: 100%;
        position: absolute;
        padding: 0px;
    }

    .page-chat .modal-image-preview .tingle-modal-box__footer .tingle-btn {
        margin-bottom: 0px;
    }

    .page-chat .uploadButton .uploadButton-button {
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
    }

    .page-chat .message-content .uploadButton .uploadButton-button {
        margin-right: -20px;
    }

    .page-chat #header-container2 .uploadButton .uploadButton-button i {
        color: #fff !important;
    }

    .page-chat .message-content .uploadButton .uploadButton-button i {
        color: #333 !important;
        font-size: 28px;
    }

    .page-chat .uploadButton {  
        background: transparent !important;
        border: none !important;
        width: auto;
        float: right;
    }

    .page-chat .message-bubble .message-text img {
        max-width: 250px;
    }

    .page-chat .empty {
        height: 100%;
        background: #f9f9f9;
        border-left: 1px solid #ddd;
    }

    .page-chat .empty .message-content-inner {
        display: flex;
        flex-direction: row;
        align-items: center;        
    }

    .page-chat .empty center {
        width: 100%;
    }

    .page-chat .empty i {
        font-size: 80px;
    }

    @media only screen and (max-width: 500px) { 



        .page-chat .message-bubble .message-text img {
            max-width: 100%;
        }

        .page-chat .uploadButton .uploadButton-button {
            background: transparent !important;
            border: none !important;
        }
        .page-chat .uploadButton {
            margin-bottom: 0px;
            margin-top: 9px;    
            background: transparent !important;
            border: none !important;
            width: 100% !important;
        }

        .page-chat .message-by-headline {
            height: auto !important;
        }

        .page-chat .messages-container-inner .message-by-headline span {    
            font-size: 11px;
            margin-top: 7px;
            top: 0px;
            right: 0px;
        }
        
        .page-chat .messages-container-inner .messages-inbox .message-by p {
            margin-top: -8px;
        }   
        .page-chat .dashboard-content-inner {
            padding: 0px !important;
        }
        .page-chat .simplebar-track.vertical {
            display: none !important;
        }
        .page-chat .messages-container {
            border: none !important;
        }
        .page-chat .simplebar-content {
            overflow-x: hidden !important;
            overflow-y: hidden !important;
        }
        .page-chat .messages-inbox ul {
            max-height: 100%;
        }
        .page-chat .message-content .messages-headline {
            padding-left: 10px;
            padding-top: 0px;
            padding-bottom: 0px;
        }
        .page-chat .message-content-inner, .page-chat .messages-container-inner {
            overflow-y: scroll !important;
            height: 100%;
        }
        .page-chat .message-content .message-content-inner {
            height: calc(100vh - 60px) !important;
            padding: 20px 20px 10px 15px;
            padding-bottom: 60px !important;
        }
        .page-chat .messages-inbox .messages-headline {
            padding: 10px;
        }
        .page-chat #wrapper {
            padding-bottom: 0px !important;
        }
        .page-chat .message-reply button {
            padding: 9px;
            right: 10px;
        }
        .page-chat .message-reply textarea {
            margin: 0px 10px 0 0;
        }

        .page-chat .page-title {
            height: 60px;
           line-height: 60px;   
        }
        .page-chat .message-reply {
            position: absolute;
            bottom: 0px;
            left: 0px;
            right: 0px;
            background: #fff;
        }   
        .page-chat .messages-container-inner .message-avatar .img {
            height: 50px;
            width: 50px;
        }   
        .page-chat .messages-container-inner .messages-inbox ul li a {
            padding: 15px;
            padding-left: 10px;
        }
        .page-chat .messages-container-inner .messages-inbox .message-avatar {
            left: 10px;
        }   
        .page-chat .messages-container-inner .message-by-headline h5 {
            /*margin-top: 0px !important;*/
            line-height: 20px;
            margin-top: 5px !important;
        }
        .page-chat .datetime-xs {
            display: inline-block !important;
        }
        .page-chat .message-by-headline h5 {
            height: 19px !important;
        }   

        .page-chat .page-title {
            height: 20px;
            overflow: hidden;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-left: 40px;
            padding-right: 40px;
            line-height: 22px !important;
            position: absolute;
            top: 21px;
            left: 0px;
            right: 0px;     
        }

        #header-container2 {
            position: fixed;
            top: 0px;
            left: 0px;
            right: 0px;
            z-index: 100;            
        }

        .page-chat .content-load {
            min-height: auto !important;
        }
    }

    /* Small Devices, Tablets */
    @media only screen and (min-width : 768px) and (orientation : portrait) and (max-width: 1024px) {
        .page-chat .simplebar-scroll-content {
            overflow-x: hidden !important;
            overflow-y: hidden !important;
        }
        .dashboard-content-inner {
            height: 100% !important;
            /*margin-top: -60px;*/
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Chat.vue